var _ = require("lodash");

/**
 * replace each occurrence of "${var}" with `rules[var]` in `str`.
 * @param {string} str - a string to transform
 * @param {Object} rules - an object with string values
 * @return a string
 * @memberof module:RefText
 */
function replaceFormatedString(str, rules) {
  var names = str.match(/\$\{[^\b\{\}]+\}/g)
    .map(function(s) {
      return s.substr(2, s.length - 3);
    });
  names = _.uniq(names);
  function reducer(result, name) {
    if(!rules[name]) {
      console.error(str);
      console.error(rules);
      throw "There is no " + name + " value";
    }
    return result.replace("${" + name + "}", rules[name]);
  }
  return _.reduce(names, reducer, str);
}

module.exports = replaceFormatedString;
